import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withTranslation, Trans } from 'react-i18next';
import { withStore } from '../../../../../../store/rootStore';
import ColorSelector from '../../../../../ColorSelector';
import { MyInput } from '../../../../../Base/Form';
import { LABELS_COLORS } from '../../../../../../constants';
import styles from './LabelsForm.module.scss';
class LabelsForm extends Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "generateIdFromName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (name) => {
                return name
                    .toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\p{L}\p{N}-]+/gu, '-')
                    .replace(/-+/g, '-')
                    .replace(/^-+|-+$/g, '');
            }
        });
        Object.defineProperty(this, "stateToLabelData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return {
                    id: this.state.id,
                    name: this.state.name,
                    color: this.state.color,
                };
            }
        });
        Object.defineProperty(this, "onFormInputChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newState) => {
                // If ID is being changed, mark it as manually edited
                if ('id' in newState) {
                    this.setState(Object.assign(Object.assign({}, newState), { wasIdManuallyEdited: true }));
                }
                else {
                    this.setState(newState);
                }
            }
        });
        Object.defineProperty(this, "canBeSaved", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { name, color, id } = this.state;
                return name.trim().length > 0 && color.trim().length > 0 && (!id || id.trim().length > 0);
            }
        });
        const { entity } = props;
        this.state = {
            id: entity === null || entity === void 0 ? void 0 : entity.id,
            name: (entity === null || entity === void 0 ? void 0 : entity.name) || '',
            color: (entity === null || entity === void 0 ? void 0 : entity.color) || LABELS_COLORS[0],
            wasIdManuallyEdited: false,
        };
    }
    componentDidMount() {
        this.props.onInput(this.stateToLabelData(), this.canBeSaved());
    }
    componentDidUpdate(prevProps, prevState) {
        const { entity } = this.props;
        if (entity && entity !== prevProps.entity) {
            this.setState({
                id: entity.id,
                name: entity.name,
                color: entity.color,
                wasIdManuallyEdited: false,
            }, () => {
                this.props.onInput(this.stateToLabelData(), this.canBeSaved());
            });
        }
        else if (prevState.name !== this.state.name || prevState.color !== this.state.color) {
            // Only update ID from name if we're creating a new label and ID wasn't manually edited
            if (prevState.name !== this.state.name && !this.props.entity && !this.state.wasIdManuallyEdited) {
                const generatedId = this.generateIdFromName(this.state.name);
                this.setState({ id: generatedId }, () => {
                    this.props.onInput(this.stateToLabelData(), this.canBeSaved());
                });
            }
            else {
                this.props.onInput(this.stateToLabelData(), this.canBeSaved());
            }
        }
    }
    render() {
        const { t, error, loading } = this.props;
        const { name, color, id } = this.state;
        return (React.createElement("div", { className: styles.formContainer },
            !!error && (React.createElement("div", { className: styles.errorMessageContainer }, typeof error === 'string' ? error : t('common.unknownError', 'An unknown error occurred'))),
            React.createElement("fieldset", { disabled: loading },
                React.createElement("div", { className: styles.labeledInput },
                    React.createElement("label", { htmlFor: "labelName" },
                        React.createElement(Trans, { i18nKey: "labelName" })),
                    React.createElement(MyInput, { id: "labelName", value: name, onChangeHandler: (value) => this.onFormInputChange({ name: value }), placeholder: t('enterLabelName', 'Enter label name'), maxLength: 50 })),
                React.createElement("div", { className: styles.labeledInput },
                    React.createElement("label", { htmlFor: "labelId" },
                        React.createElement(Trans, { i18nKey: "labelId" }),
                        !this.props.entity && (React.createElement("span", { className: styles.helperText },
                            "(",
                            t('autoLabelId', 'Auto-generated from name, can be edited'),
                            ")"))),
                    React.createElement(MyInput, { id: "labelId", value: id || '', onChangeHandler: (value) => this.onFormInputChange({ id: value }), placeholder: t('enterLabelId', 'Enter label ID'), maxLength: 50, disabled: !!this.props.entity })),
                React.createElement("div", { className: styles.labeledInput },
                    React.createElement("label", null,
                        React.createElement(Trans, { i18nKey: "labelColor" })),
                    React.createElement(ColorSelector, { color: color, onChange: (selectedColor) => this.onFormInputChange({ color: selectedColor }), colors: LABELS_COLORS })))));
    }
}
export default withTranslation()(withStore(observer(LabelsForm)));
